// Splits an About document into its `## ` sections. Each heading carries a stable id in the Pandoc/kramdown
// attribute form (`## 保护隐私 {#privacy}`) so the page nav and deep links (/about#terms) work the same in
// every language; a heading without one falls back to its position.

export interface AboutSection {
  id: string;
  title: string;
  body: string;
}

const HEADING = /^##\s+(.*?)(?:\s*\{#([a-z0-9-]+)\})?\s*$/;

export function splitSections(markdown: string): { intro: string; sections: AboutSection[] } {
  const lines = markdown.replace(/\r\n?/g, '\n').split('\n');
  const intro: string[] = [];
  const sections: AboutSection[] = [];
  let current: { id: string; title: string; lines: string[] } | null = null;
  for (const line of lines) {
    const h = HEADING.exec(line);
    if (h) {
      if (current) sections.push({ id: current.id, title: current.title, body: current.lines.join('\n').trim() });
      current = { id: h[2] ?? `s${sections.length + 1}`, title: h[1].trim(), lines: [] };
    } else if (current) {
      current.lines.push(line);
    } else {
      intro.push(line);
    }
  }
  if (current) sections.push({ id: current.id, title: current.title, body: current.lines.join('\n').trim() });
  return { intro: intro.join('\n').trim(), sections };
}
